import { atom } from '@exodus/headless-ui';
import limitsAtom from './limits.js';
import maxQuoteAtom from './max-quote.js';
import fromAssetAtom from './from-asset.js';
import toAssetAtom from './to-asset.js';
import fromWalletAccountAtom from './from-wallet-account.js';
import fromSpendableBalanceAtom from './from-spendable-balance.js';
const buildPrefillsKey = (fromAssetName, toAssetName, walletAccount) => `${fromAssetName}|${toAssetName}|${walletAccount}`;
const maxBalanceAtom = atom(async (get) => {
    const balance = get(fromSpendableBalanceAtom);
    if (balance.isZero)
        return balance;
    const fromAsset = get(fromAssetAtom);
    const isFromFeeAsset = fromAsset.name === fromAsset.feeAsset.name;
    if (!isFromFeeAsset)
        return balance;
    const maxQuote = await get(maxQuoteAtom);
    if (maxQuote && maxQuote.fromAmount.gt(balance))
        return balance;
    return maxQuote?.fromAmount || balance;
});
const prefillsAtom = atom(async (get) => {
    const fromAsset = get(fromAssetAtom);
    const [limits, maxBalance] = await Promise.all([get(limitsAtom), get(maxBalanceAtom)]);
    if (!limits) {
        return {
            min: { label: 'MIN', value: fromAsset.currency.ZERO },
            half: { label: 'HALF', value: fromAsset.currency.ZERO },
            max: { label: 'MAX', value: fromAsset.currency.ZERO },
        };
    }
    const isAll = maxBalance.gte(limits.ExactIn.min) && maxBalance.lte(limits.ExactIn.max);
    const min = limits.ExactIn.min;
    const max = isAll ? maxBalance : limits.ExactIn.max;
    const half = max.div(2);
    return {
        min: { label: 'MIN', value: min },
        half: { label: 'HALF', value: half },
        max: { label: isAll ? 'ALL' : 'MAX', value: max },
    };
});
prefillsAtom.cacheKey = (get) => buildPrefillsKey(get(fromAssetAtom).name, get(toAssetAtom).name, get(fromWalletAccountAtom).toString());
export default prefillsAtom;
